<template>
    <div style="position: relative;left: 0;top: 0;bottom: 0;right: 0;width:100%;">
        <div class="left-head">
            <el-row>
                <el-col :span="24">用户信息</el-col>
            </el-row>
        </div>
        <div class="left">
            <div class="left-flex">
            <el-row>
                <el-col :span="6" class="userInfo">
                    用户名称：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerName"></span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" class="userInfo">
                    用户编号：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerCode"></span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" class="userInfo">
                    用户地址：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerAddr"></span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" class="userInfo">
                    联系人：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerContactPerson"></span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" class="userInfo">
                    手机号码：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerMobile"></span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" class="userInfo">
                    电子邮箱：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerEmail"></span>
                </el-col>
            </el-row>
            </div>
        </div>
        <div class="right-head">
            <el-row>
                <el-col :span="24">仪表余额</el-col>
            </el-row>
        </div>
        <div class="right">
        <flex style="width: 99.99%;height: 99.99%;">
                <el-table
                        :data="meters"
                        stripe
                        height="100%"
                        size="mini"
                        ref="singleTable"
                        :cell-style="cellStyle"
                        :header-cell-style="headStyle"
                        style="width: 100%">
                    <el-table-column
                            prop="name"
                            label="仪表名称"
                            :formatter="tableStringFormat">
                    </el-table-column>
                    <el-table-column
                            prop="code"
                            label="仪表编号"
                            :formatter="tableStringFormat">
                    </el-table-column>
                    <el-table-column
                            prop="meter_num"
                            label="表号"
                            :formatter="tableStringFormat">
                    </el-table-column>
                    <el-table-column
                            prop="strname"
                            label="能源类型"
                            :formatter="tableStringFormat">
                    </el-table-column>
                    <el-table-column
                            prop="balance"
                            label="当前余额（元）"
                            :formatter="tableNumberFormat">
                    </el-table-column>
                    <el-table-column
                            prop="readingTime"
                            label="抄表时间"
                            :formatter="tableTimeFormat">
                    </el-table-column>
                    <el-table-column
                            prop="meterConnectionStatus"
                            label="通信状态">
                        <template slot-scope="scope">
                            <svg-icon :icon-class="scope.row.meterConnectionStatus ===1 ? 'wifi_green' : 'wifi_red'"></svg-icon>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                        　　<el-button size="mini" type="primary" @click="payClick(scope.row.id,scope.row.meterConnectionStatus)">充值</el-button>
                        </template>
                    </el-table-column>
                </el-table>
        </flex>
        </div>
    </div>
</template>

<script>
  import {queryCustomerById} from '@/api/customerUser'
  import {getMetersByUser} from '@/api/Meter'
  import {format} from '@/utils/time'
  import Flex from '@/components/Flex'
  export default {
    name: "queryBalance",
    components: {
      'flex': Flex
    },
    data() {
      return {
        customerName:"",
        customerCode:"",
        customerMobile:"",
        customerAddr:"",
        customerEmail:"",
        customerContactPerson:"",
        customerId:this.$store.getters.customerId,
        customerUserId:this.$store.getters.userId,
        meters: []
      }
    },
    mounted() {
      this.queryUserInfo() //查询用户信息
      this.queryMeters() //查询仪表信息
    },
    methods: {
      tableStringFormat(row, column, cellValue){   //表格中字符串格式化
        if(cellValue!==null&&cellValue!==undefined&&cellValue!==""){
          return cellValue
        }
        return "--"
      },
      tableNumberFormat(row, column, cellValue){   //表格中数字格式化
        if(cellValue!==null&&cellValue!==undefined&&cellValue!==""){
          return cellValue.toFixed(2)
        }
        return "--"
      },
      tableTimeFormat(row, column, cellValue){   //表格中时间格式化
        if(cellValue!==null&&cellValue!==undefined&&cellValue!==""){
          return format(cellValue,"YYYY-MM-DD HH:mm:ss")
        }
        return "--"
      },
      cellStyle({row, column, rowIndex, columnIndex}){  //单元格样式
        if(columnIndex==4){
          return "text-align: center;color: #1CA4B3;"
        }
        return "text-align: center;"
      },
      headStyle({row, rowIndex}){  //表头样式
        return "text-align: center;"
      },
      payClick(id,status) {  //点击充值按钮
        if(status == 0){
          this.$message({
            type: 'error',
            message: '该仪表通信中断，无法充值'
          })
          return
        }
        this.$router.push({ //跳转自助充值页面
          path: '/iPay/index',
          query: {
            meterId: id
          }
        })
      },
      queryMeters() { //查询仪表信息
        getMetersByUser(this.customerId,this.customerUserId).then(response => { //查询仪表信息
          this.meters=response.infoJson
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '仪表信息查询失败'
          })
        })
      },
      queryUserInfo() { //查询用户信息
        queryCustomerById(this.customerUserId).then(response => {
          let user=response.infoJson
          if(user !== null && user!==undefined){
            if(user.realName !== null && user.realName !== undefined && user.realName !==""){
              this.customerName=user.realName
            }else{
              this.customerName="--"
            }
            if(user.name !== null && user.name !== undefined && user.name !==""){
              this.customerCode=user.name
            }else{
              this.customerCode="--"
            }
            if(user.mobile !== null && user.mobile !== undefined && user.mobile !==""){
              this.customerMobile=user.mobile
            }else{
              this.customerMobile="--"
            }
            if(user.address !== null && user.address !== undefined && user.address !==""){
              this.customerAddr=user.address
            }else{
              this.customerAddr="--"
            }
            if(user.email !== null && user.email !== undefined && user.email !==""){
              this.customerEmail=user.email
            }else{
              this.customerEmail="--"
            }
            if(user.contactPerson !== null && user.contactPerson !== undefined && user.contactPerson !==""){
              this.customerContactPerson=user.contactPerson
            }else{
              this.customerContactPerson="--"
            }
          }else{
            this.$message({
              type: 'error',
              message: '用户信息查询失败'
            })
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '用户信息查询失败'
          })
        })
      }
    }
  }
</script>

<style scoped>
    .el-col{
        line-height: 40px;
    }
    .el-col-24{
        font-size: 15px;
        font-weight: 600;
    }
    .left{
        position: absolute;
        left: 0;
        top: 40px;
        bottom: 0;
        width:26%;
        height:calc(95% - 40px);
        background-color: #ffffff;
        border-radius: 4px;
        overflow: auto;
    }
    .left-flex{
        display:flex;
        flex-direction: column;
        height:calc(100% - 20px);
        width:calc(100% - 40px);
        margin: 10px 10px 10px 30px;
        font-size: 14px;
    }
    .right{
        position: absolute;
        left: 29%;
        top: 40px;
        bottom: 0;
        width:71%;
        height:calc(95% - 40px);
        background-color: #ffffff;
        border-radius: 4px;
        overflow: auto;
    }
    .left-head{
        position: absolute;
        left: 0;
        width:26%;
    }
    .right-head{
        position: absolute;
        left: 29%;
        width:71%;
    }
    .userInfo{
        color:#6A6A6A;
        font-size: 14px;
    }
    .userInfoValue{
        font-size: 18px;
        color:black;
        word-break: break-all;
    }
    .dialogInfo{
        line-height: 20px;
    }
</style>
